import {
  FETCH_MERCHANT_RECURRING_PLANS_LOADING,
  FETCH_MERCHANT_RECURRING_PLANS_SUCCESS,
  FETCH_MERCHANT_RECURRING_PLANS_FAILED,
} from "../types";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const merchantRecurringReduces = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_MERCHANT_RECURRING_PLANS_LOADING:
      return { ...state, loading: true, error: null };
    case FETCH_MERCHANT_RECURRING_PLANS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_MERCHANT_RECURRING_PLANS_FAILED:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
